<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('profile_registration') }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">

              <div v-if="tokenState===''">
                <loading></loading>
              </div>

              <div v-else-if="tokenState==='invalid'">
                <h4>{{ $t('profile_invalid_token') }}</h4>
              </div>

              <div v-else-if="registrationSent"
                   class="card-body p-t-25 p-b-30">
                {{ $t('profile_registration_success') }}
              </div>

              <div v-else
                   class="card-body p-t-25 p-b-30">
                <form>
                  <div class="form-group contact">
                    <label for="username">
                      <p class="adviestitle">{{ $t('profile_username') }}:</p>
                    </label>
                    {{userName}}
                  </div>
                  <div class="form-group contact">
                    <label for="email">
                      <p class="adviestitle">{{ $t('profile_email') }}:</p>
                    </label>
                    {{email}}
                  </div>
                  <div class="form-group contact">
                    <label for="password">
                      <p class="adviestitle">{{ $t('profile_password') }}:</p>
                    </label>
                    <b-form-input type="password"
                                  class="form-control form-control-lg"
                                  :class="{'form-control-not-valid': errors.has('password')}"
                                  v-validate="'required|min:8'"
                                  id="password"
                                  ref="password"
                                  name="password"
                                  :placeholder="$t('profile_password')"
                                  v-model="userData.Password">
                    </b-form-input>
                    <small class="form-text text-danger" v-if="errors.has('password')">
                      {{ errors.first('password') }}
                    </small>
                  </div>
                  <div class="form-group contact">
                    <label for="repeatpassword">
                      <p class="adviestitle">{{ $t('profile_repeat_pwd') }}:</p>
                    </label>
                    <b-form-input type="password"
                                  class="form-control form-control-lg"
                                  :class="{'form-control-not-valid': errors.has('repeatpassword')}"
                                  v-validate="'required|min:8|confirmed:password'"
                                  id="repeatpassword"
                                  ref="repeatpassword"
                                  name="repeatpassword"
                                  :placeholder="$t('profile_repeat_pwd')"
                                  v-model="repeatPassword">
                    </b-form-input>
                    <small class="form-text text-danger" v-if="errors.has('repeatpassword')">
                      {{ errors.first('repeatpassword') }}
                    </small>
                  </div>
                  <div class="form-group contact">
                    <label for="firstname">
                      <p class="adviestitle">{{ $t('profile_first_name') }}:</p>
                    </label>
                    <b-form-input type="text"
                                  class="form-control form-control-lg"
                                  id="firstname"
                                  :placeholder="$t('profile_first_name')"
                                  v-model="userData.FirstName">
                    </b-form-input>
                  </div>
                  <div class="form-group contact">
                    <label for="lastname">
                      <p class="adviestitle">{{ $t('profile_last_name') }}:</p>
                    </label>
                    <b-form-input type="text"
                                  class="form-control form-control-lg"
                                  id="lastname"
                                  :placeholder="$t('profile_last_name')"
                                  v-model="userData.LastName">
                    </b-form-input>
                  </div>
                  <div class="form-group contact">
                    <label for="birthdate">
                      <p class="adviestitle">{{ $t('profile_birth_date') }}:</p>
                    </label>
                    <b-form-input type="date"
                                  class="form-control form-control-lg"
                                  id="birthdate"
                                  :placeholder="$t('profile_last_name')"
                                  v-model="userData.BirthDate">
                    </b-form-input>
                  </div>
                  <div class="form-group contact">
                    <label for="gender">
                      <p class="adviestitle">{{ $t('profile_gender') }}:</p>
                    </label>
                    <b-form-radio-group v-model="userData.Gender"
                                        id="gender"
                                        stacked>
                      <b-form-radio value="M">{{ $t('profile_gender_male') }}</b-form-radio>
                      <b-form-radio value="F">{{ $t('profile_gender_female') }}</b-form-radio>
                    </b-form-radio-group>
                  </div>
                  <div class="form-group contact" v-if="departments.length > 1">
                    <label for="department">
                      <p class="adviestitle">{{ $t('profile_department') }}:</p>
                    </label>
                    <b-form-select
                            class="form-control form-control-lg text-center"
                                   v-model="userData.Department"
                                   id="department">
                      <option value="null" disabled>
                        <p>{{ $t('profile_select_department') }}</p>
                      </option>
                      <option v-for="dep in departments"
                              :value="dep.Id">
                        <p>{{ dep.Value }}</p>
                      </option>
                    </b-form-select>
                  </div>
                  <div class="form-group contact"  v-if="targetGroups.length > 1">
                    <label for="targetgroup">
                      <p class="adviestitle">{{ $t('profile_targetgroup') }}:</p>
                    </label>
                    <b-form-select class="form-control form-control-lg text-center"
                                   v-model="userData.TargetGroup"
                                   id="targetgroup">
                      <option value="null" disabled>
                        <p>{{ $t('profile_selecttargetgroup') }}</p>
                      </option>
                      <option v-for="tgrp in targetGroups"
                              :value="tgrp.Id">
                        <p>{{ tgrp.Value }}</p>
                      </option>
                    </b-form-select>
                  </div>

                </form>
                <button class="advicebutton text-white confirm"
                        @click="submitRegistration"
                        :disabled="errors.any()">
                  {{ $t('profile_send') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Loading from '../utilities/Loading'

  export default {
    props: ['token'],
    components: {Loading},
    methods: {
      ...mapActions([
        'userLoadRegistration',
        'userSendRegistration',
      ]),
      submitRegistration () {
        if (this.userData.Password != '') {
          if (this.departments.length == 1) {
            this.userData.Department = this.departments[0].Id
          }
          if (this.targetGroups.length == 1) {
            this.userData.TargetGroup = this.targetGroups[0].Id
          }
          this.userSendRegistration(this.userData).then(response => {
            this.registrationSent = true
            console.log(response)
            if (response.data != '') {
              this.$router.push({ name: 'home' })
            }
          }, error => {
            console.error(error)
          })
        } else {
          console.error('No password set')
        }
      }
    },
    data() {
      return {
        registrationSent: false,
        tokenState: '',
        userName: '',
        email: '',
        departments: [],
        targetGroups: [],
        repeatPassword: '',
        userData: {
          UserId: '',
          RegToken: '',
          Password: '',
          FirstName: '',
          LastName: '',
          BirthDate: '1980-01-01',
          Gender: '',
          Department: '',
          TargetGroup: '',
        }
      }
    },
    created() {
      this.userLoadRegistration(this.token).then(response => {
        this.userData.RegToken = this.token
        this.userData.UserId = response.data.UserId
        this.userName = response.data.UserName
        this.email = response.data.Email
        this.departments = response.data.Departments
        this.targetGroups = response.data.TargetGroups
        this.tokenState = 'valid'
        console.log(response)
      }, error => {
        console.error(error)
        if (error.status === 403) {
          this.tokenState = 'invalid'
        }
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile/Registration.vue